<div class="pb-3">
  <div class="kyc-apt-blk-desktop">
    <img
      class="d-inline-block align-top"
      src="/assets/CRI/kyc/kyc-expired-blocked-info-desktop.png"
      alt="kyc-img" />
    <div style="text-align: center !important; padding-top: 10px">
      <button
        mat-dialog-close
        class="btn btn-secondary btn-block w-auto mx-auto alert-completeKycBtn"
        type="button"
        [routerLink]="['/app/profile']"
        [queryParams]="{ completeKyc: true }">
        {{ 'withdraw.completeInformation' | translate }}
      </button>
    </div>
  </div>
</div>
